/**
 * resolves which metadoc pdf url to use based on grouping source
 * keeps ops vs ai selection logic in one place
 */
import type { Metadoc } from "services/metadoc-api";
import type { GroupingSource } from "services/metadoc-api";

type UseResolvedMetadocDownloadArgs = {
  metadoc?: Metadoc;
  groupingSource: GroupingSource;
};

type ResolvedMetadocDownload = {
  resolvedDownloadUrl: string;
  shouldUsePreAiPdf: boolean;
  hasAiDownloadUrl: boolean;
  hasResolvedDownloadUrl: boolean;
};

export const useResolvedMetadocDownload = ({
  metadoc,
  groupingSource,
}: UseResolvedMetadocDownloadArgs): ResolvedMetadocDownload => {
  const shouldUsePreAiPdf =
    groupingSource === "OPS" && !!metadoc?.pre_ai_run_download_url;

  const resolvedDownloadUrl = shouldUsePreAiPdf
    ? (metadoc?.pre_ai_run_download_url ?? "")
    : (metadoc?.download_url ?? "");

  return {
    resolvedDownloadUrl,
    shouldUsePreAiPdf,
    hasAiDownloadUrl: !!metadoc?.download_url,
    hasResolvedDownloadUrl: !!resolvedDownloadUrl,
  };
};
